<template>
  <div>
    <div class="page-header">
      <span class="h3">{{ this.project_area.name }}</span>
    </div>

    <ul class="list-style-none p-0">

          <draggable :data-project-area-id="project_area.id" class="dragArea list-group" :list="project_area.projects" :options="{group:'projects', delay:200}" @change="log" @add="add"  handle=".sort-handle">
            <li v-for="project in project_area.projects" :key="project.id" :data-project-id="project.id" class="list-group-item">
              <span class=" d-flex">
                <ProjectTitle :project=project />
                <span class='push-right'>
                  <i class="material-icons pointer ml-1 sort-handle">reorder</i>
                </span>
              </span>
            </li>
        </draggable>
      </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import ProjectTitle from "components/ProjectTitle";
import NewQuickTask from "components/NewQuickTask";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    ProjectTitle,
    draggable
  },
  computed: {
    project_area: {
      get() {
        return this.$store.state.project_areas.find(area => {
          return area.id == this.$route.params.id
        })
      }
    }
  },
  methods: {
    log: function(evt) {
      if(evt.moved){
        api.changeProjectSort(evt.moved.element.id, evt.moved.newIndex)
      }
    },
    add: function(evt) {
      api.moveProject(evt.item.dataset.projectId, evt.to.dataset.projectAreaId, evt.newIndex)
    },
    deleteProjectArea(project_area) {
      api.deleteProjectArea(project_area.id).then(response => {
        $('body').removeClass('modal-open')
        $(".modal-backdrop").hide();
      });
    },
    updateProjectArea(project_area) {
      if(project_area.name){
        api.updateProjectArea(project_area.id, { name: project_area.name }).then(response => {
          $('#editProjectAreaModal' + project_area.id).modal('hide')
        });
      }
    }
  }  
};
</script>
